import { Text, HStack, VStack, IconStatusNew } from '@genial/components';
import React from 'react';

import { FixedFeeRelatedTermContentProps } from '.';

export const FixedFeeRelatedTermMobile: React.FC<FixedFeeRelatedTermContentProps> = ({
  relatedTerm,
}) => {
  return (
    <HStack
      p="inset.xs"
      backgroundColor="backgroundshade"
      justifyContent="space-between"
      borderRadius="sm"
      space="inline.nano">
      <VStack space="stack.quarck" flex={1}>
        <Text color="neutral.medium" fontSize="xs">
          Termo atual
        </Text>
        <VStack space="inline.quarck" flex={1}>
          <Text>{relatedTerm.term}</Text>
          <IconStatusNew
            color={relatedTerm.statusColor}
            icon={relatedTerm.statusIcon}
            status={relatedTerm.status}
          />
        </VStack>
      </VStack>

      <VStack space="stack.quarck" alignItems="flex-end">
        <Text color="neutral.medium" fontSize="xs">
          Iniciado em
        </Text>
        <Text>{relatedTerm.contractDateNormalized}</Text>
      </VStack>
    </HStack>
  );
};
